import React from "react";
var __jsx = React.createElement;
import isEmpty from 'lodash/isEmpty';
import { ImageDropzone } from './ImageDropzone';
import { ImagePreview } from './ImagePreview';

var isValidUrl = function isValidUrl(imgSrc) {
  return !isEmpty(imgSrc);
};

var ImageDropzoneOrPreview = function ImageDropzoneOrPreview(_ref) {
  var onImageDropped = _ref.onImageDropped,
      onImageDeleted = _ref.onImageDeleted,
      imageRatio = _ref.imageRatio,
      imgSrc = _ref.imgSrc,
      onCropButtonClick = _ref.onCropButtonClick,
      imageConstraints = _ref.imageConstraints;

  if (isValidUrl(imgSrc)) {
    return __jsx(ImagePreview, {
      imgUrl: imgSrc,
      onReplaceButtonClick: onImageDeleted,
      onCropButtonClick: onCropButtonClick
    });
  }

  return __jsx(ImageDropzone, {
    onImageDropped: onImageDropped,
    imageRatio: imageRatio,
    imageConstraints: imageConstraints
  });
};

export default ImageDropzoneOrPreview;